import React, { useEffect, useState } from 'react';
import Button from '../../Buttons/Button/Button';
import styled from 'styled-components';
// import 'react-responsive-carousel/lib/styles/carousel.min.css';
// import { Carousel } from 'react-responsive-carousel';
import SFCarousel from '../../../FeatureComponents/Response/Templates/SFCarousel';
import { saveStateSession } from '../../../FlyfishComponents/flyfishutils/utils';
// import QuantityPlus from '../../../../../assets/imgs/add-quantity.svg'
// import QuantityMinus from '../../../../../assets/imgs/remove-quantity.svg'
// import QuantityError from '../../../../../assets/imgs/quantity-error.svg'

interface Props {
	data: any;
	isMultiChoice?: boolean;
	shouldDisableActions?: boolean;
	handleSubmit?: Function;
	isMultiSelect?: boolean;
	isInsideCampaign: boolean;
	botImageCheck: boolean;
	index: number;
	logoImagePath?: string;
	voiceResponse?: boolean;
	langCode?: string;
	lengthArray: number;
	flyFishChangesReq: boolean;
	addUserResponse: Function;
	createCart: Function;
	configData: any;
}

const ShopifyProduct = styled.div`
	.disable-product-details {
		cursor: not-allowed;
		background-color: ${(props: any) => {
			return props.foreground + '53'; // 0.6
		}};
		opacity: 0.6;
	}
	.card-container {
		border-bottom: 1px solid
			${(props: any) => {
				return props.foreground + '33'; // 0.2
			}};
	}
	.product-price,
	.product-desc-price {
		.caption-text {
			color: ${(props: any) => {
				return props.foreground + '99'; // 0.6
			}};
		}
	}
	.product-description {
		body-text-2 {
			color: ${(props: any) => {
				return props.foreground + '99'; // 0.6
			}};
			font-weight: normal;
		}
	}
	.overline-text {
		color: ${(props: any) => {
			return props.foreground + '99'; // 0.6
		}};
	}
	.quantity-error {
		.caption-text {
			color: ${(props: any) => {
				return props.foreground + '99'; // 0.6
			}};
		}
	}
	.show-data {
		.caption-text {
			border: 1px solid
				${(props: any) => {
					return props.foreground + '33'; // 0.2
				}};
			&:hover {
				background-color: ${(props: any) => {
					return props.foreground + '10'; // 0.05
				}};
			}
			&:focus,
			&:active {
				background-color: ${(props: any) => {
					return props.foreground + '18'; // 0.10
				}};
			}
		}
	}
	.product-quantity-button {
		border-radius: 8px !important;
		border: solid 1px rgba(0, 0, 0, 0.2);
		background-color: rgba(255, 255, 255, 0);
		.caption-text {
			border-left: solid 1px rgba(0, 0, 0, 0.2);
			border-right: solid 1px rgba(0, 0, 0, 0.2);
		}
		.reduce-quantity,
		.add-quantity {
			background-color:${(props: any) => props.colorScale && props.colorScale[9]}
			&:hover {
				background-color: ${(props: any) => {
					return props.foreground + '18'; // 0.10
				}};
			}
			&:focus,
			&:active {
				background-color: ${(props: any) => {
					return props.foreground + '33'; // 0.20
				}};
			}
		}
	}
`;

const styleVars = getComputedStyle(document.querySelector(':root'));
export const AddToCart = (props: Props) => {
	const handleSubmit = props.handleSubmit;
	const addUserResponse = props.addUserResponse;
	const createCart = props.createCart;
	const [selectedProduct, setSelectedProduct] = React.useState('');
	const [variantSize, setVariantSize] = useState([]);
	const [variantColor, setVariantColor] = useState([]);
	const [variantStorage, setVariantStorage] = useState([]);
	const [variantStyle, setVariantStyle] = useState([]);
	let [style, selectedStyle] = useState('');
	let [size, selectedSize] = useState('Xl');
	let [color, selectedColor] = useState('Black');
	let [storage, selectedStorage] = useState('1 TB');
	let [quantity, setQuantity] = useState(1);
	const [quantityError, setQuantityError] = useState(false);

	let shopifyData: any;
	const getFormatData = (data: any) => {
		shopifyData = JSON.parse(data.displayResponse);

		let totalShopifyProducts = [];
		shopifyData.data.product.images.map((url: any) => {
			let addItemToShopify = {
				resourceURL: url.src,
			};
			totalShopifyProducts.push(addItemToShopify);
		});

		let shopifyCartCollection: any;
		if (totalShopifyProducts.length > 0) {
			shopifyCartCollection = {
				displayResponse: '',
				responseType: 'CAROUSEL',
				listResponseType: 'MULTICHOICE',
				lists: { items: totalShopifyProducts },
			};
		} else {
			shopifyCartCollection = {
				displayResponse: '',
				responseType: 'SIMPLE',
			};
		}
		return shopifyCartCollection;
	};

	useEffect(() => {
		if (shopifyData.data.product.options.length > 0) {
			shopifyData.data.product.options.map((eachOption) => {
				if (eachOption.name === 'Size') {
					setVariantSize(eachOption.values);
				} else if (eachOption.name === 'Color') {
					setVariantColor(eachOption.values);
				} else if (eachOption.name === 'Storage') {
					setVariantStorage(eachOption.values);
				} else if (eachOption.name === 'Style') {
					setVariantStyle(eachOption.values);
				} else {
					setVariantSize(eachOption.values);
				}
			});
		}
	}, [shopifyData]);

	useEffect(() => {
		let shopifyProducts = shopifyData.data.product.variants;
		selectedSize(shopifyProducts[0].option1);
		selectedColor(shopifyProducts[0].option2);
		selectedStorage(shopifyProducts[0].option3);
	}, []);

	useEffect(() => {
		shopifyVariant && quantity > shopifyVariant.inventory_quantity
			? setQuantityError(true)
			: setQuantityError(false);
	}, [quantity, setQuantityError]);

	let shopifyVariant: any;
	const showProductPrice = () => {
		let shopifyProducts = shopifyData.data.product.variants;
		let shopifyPrice = shopifyProducts.filter(
			(variant: any) =>
				variant.option1 === size &&
				variant.option2 === style &&
				(variant.option3 ? variant.option3 === storage : true)
		);
		if (shopifyPrice.length > 0) {
			shopifyVariant = shopifyPrice[0];
			let addCart = `${shopifyVariant.admin_graphql_api_id}$$@$$${quantity}`;
			saveStateSession('shopify', addCart.toString());
			return shopifyVariant.compare_at_price;
		} else {
			shopifyVariant = shopifyProducts[0];
			let addCart = `${shopifyVariant.admin_graphql_api_id}$$@$$${quantity}`;
			saveStateSession('shopify', addCart.toString());
			return shopifyVariant.compare_at_price;
		}
	};

	const productPrice = (price: any, currencyCode) => {
		return currencyCode == 'USD'
			? '$' +
					Number(price)
						.toFixed(2)
						.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
			: '₹' +
					Number(price)
						.toFixed(2)
						.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	};

	let foreground = styleVars.getPropertyValue('--srvMsgColor') || '#ffffff';
	let background =
		styleVars.getPropertyValue('--srvMsgBackgorund') || '#383ff6';

	return (
		<ShopifyProduct
			className={
				props.shouldDisableActions
					? 'disable-product-details'
					: 'ff-add-to-cart-wrapper'
			}
			{...{
				background: background,
				foreground: foreground,
				...props.configData,
			}}
		>
			<div className='ff-cart-header-wrapper'>
				<div className='ff-cart-media-carousel'>
					<SFCarousel
						data={getFormatData(props.data)}
						shouldDisableActions={props.shouldDisableActions}
						isInsideCampaign={props.isInsideCampaign}
						index={props.index}
						lengthArray={props.lengthArray}
						botImageCheck={props.botImageCheck}
						logoImagePath={props.logoImagePath}
						langCode={props.langCode}
						flyFishChangesReq={props.flyFishChangesReq}
					/>
				</div>
			</div>
			<div
				className={`ff-cart-footer-wrapper ${
					props.shouldDisableActions ? 'ff-disable-card' : ''
				}`}
			>
				<div className='body-text-1'>{shopifyData.data.product.title}</div>
				<div
					className={
						showProductPrice() ? 'product-desc-price' : 'product-price'
					}
				>
					{shopifyVariant.compare_at_price ? (
						<s className='caption-text'>
							{productPrice(
								shopifyVariant.compare_at_price,
								shopifyData.data.product.currencyCode
							)}{' '}
						</s>
					) : null}
					<span className='body-text-2'>
						{productPrice(
							shopifyVariant.price,
							shopifyData.data.product.currencyCode
						)}
					</span>
				</div>
				{shopifyVariant.description ? (
					<div className='product-description'>
						<span className='body-text-2'>
							Made from breathable cotton, these shirts are great for casual
							home and active wear.
						</span>
					</div>
				) : null}

				{shopifyVariant.option1 !== 'Default Title' &&
				variantSize.length > 0 ? (
					<div className='product-size'>
						<span className='overline-text'>SIZE</span>
						<span className='show-data'>
							{variantSize.map((data: any, index: number) => {
								return (
									<span
										className={`caption-text ${
											size === data ? 'selected' : ''
										}`}
										key={index}
										onClick={() => {
											selectedSize(data);
											setQuantity(1);
											setQuantityError(false);
										}}
									>
										{data}
									</span>
								);
							})}
						</span>
					</div>
				) : null}
				{shopifyVariant.option1 !== 'Default Title' &&
				variantStyle.length > 0 ? (
					<div className='product-size'>
						<span className='overline-text'>Style</span>
						<span className='show-data'>
							{variantStyle.map((data: any, index: number) => {
								return (
									<span
										className={`caption-text ${
											style === data ? 'selected' : ''
										}`}
										key={index}
										onClick={() => {
											selectedStyle(data);
										}}
									>
										{data}
									</span>
								);
							})}
						</span>
					</div>
				) : null}

				{variantColor.length > 0 ? (
					<div className='product-color'>
						<span className='overline-text'>COLOUR</span>
						<span className='show-data'>
							{variantColor.map((data, index) => {
								return (
									<span
										className={`caption-text ${
											color === data ? 'selected' : ''
										}`}
										key={index}
										onClick={() => {
											selectedColor(data);
											setQuantity(1);
											setQuantityError(false);
										}}
									>
										{data}
									</span>
								);
							})}
						</span>
					</div>
				) : null}

				{variantStorage.length > 0 ? (
					<div className='product-storage'>
						<span className='overline-text'>STORAGE</span>
						<span className='show-data'>
							{variantStorage.map((data, index) => {
								return (
									<span
										className={`caption-text ${
											storage === data ? 'selected' : ''
										}`}
										key={index}
										onClick={() => {
											selectedStorage(data);
											setQuantity(1);
											setQuantityError(false);
										}}
									>
										{data}
									</span>
								);
							})}
						</span>
					</div>
				) : null}

				<div className='product-quantity'>
					<div className='overline-text'>QUANTITY</div>
					<div className='product-quantity-button'>
						<span
							className='reduce-quantity'
							onClick={() => {
								if (quantity > 1) {
									setQuantity(quantity - 1);
									setQuantityError(false);
								}
							}}
						>
							<svg
								xmlns='http://www.w3.org/2000/svg'
								width='20'
								height='20'
								viewBox='0 0 20 20'
							>
								<path
									data-name='Path 5'
									d='M0 0h20v20H0z'
									style={{ fill: 'none' }}
								/>
								<path
									data-name='Path 6'
									d='M15.834 10.834H4.167V9.167h11.667z'
									style={{
										fill:
											props.configData.colorMode === 'dark'
												? 'var(--selectedColor)'
												: props.configData.colorScale &&
												  props.configData.colorScale[2],
									}}
								/>
							</svg>
						</span>
						<span className='caption-text'>{quantity}</span>
						<span
							className='add-quantity'
							onClick={() => {
								if (quantity < shopifyVariant.inventory_quantity) {
									setQuantity(quantity + 1);
									setQuantityError(false);
								} else {
									setQuantityError(true);
								}
							}}
						>
							<svg
								xmlns='http://www.w3.org/2000/svg'
								width='20'
								height='20'
								viewBox='0 0 20 20'
							>
								<path
									data-name='Path 3'
									d='M0 0h20v20H0z'
									style={{ fill: 'none' }}
								/>
								<path
									data-name='Path 4'
									d='M15.834 10.834h-5v5H9.167v-5h-5V9.167h5v-5h1.667v5h5z'
									style={{
										fill:
											props.configData.colorMode === 'dark'
												? 'var(--selectedColor)'
												: props.configData.colorScale &&
												  props.configData.colorScale[2],
									}}
								/>
							</svg>
						</span>
					</div>
					{quantityError ? (
						<div className='quantity-error'>
							<svg
								xmlns='http://www.w3.org/2000/svg'
								width='16'
								height='16'
								viewBox='0 0 16 16'
							>
								<path
									data-name='Path 2173'
									d='M0 0h16v16H0z'
									style={{ fill: 'none' }}
								/>
								<path
									data-name='Path 2174'
									d='M7.4 9.8h1.2V11H7.4zm0-4.8h1.2v3.6H7.4zm.594-3A6 6 0 1 0 14 8a6 6 0 0 0-6.006-6zM8 12.8A4.8 4.8 0 1 1 12.8 8 4.8 4.8 0 0 1 8 12.8z'
									style={{ fill: `${foreground}99` }}
								/>
							</svg>
							<span className='caption-text'>
								You can only add {shopifyVariant.inventory_quantity} of this
								item to your cart
							</span>
						</div>
					) : null}
				</div>

				<div className='product-add-to-cart-button'>
					<Button
						fullWidth={true}
						//   disabled={}
						//   className={`login-button ${
						//     props.shouldDisableActions ? 'action-disabled' : ''
						//   }`}
						className='cart-button'
						onClick={() => {
							let addCart = `${shopifyVariant.admin_graphql_api_id}$$@$$${quantity}`;
							addUserResponse('Add to Cart', Date.now());
							createCart(shopifyVariant.admin_graphql_api_id, quantity);
							//handleSubmit(addCart.toString(), {}, { isHidden: true });
						}}
						variant={'filled'}
						label='Add to Cart'
						style={{
							backgroundColor: `${
								props.configData.colorMode === 'dark'
									? 'var(--selectedColor)'
									: props.configData.colorScale[1]
							}`,
							color: '#ffffff',
						}}
					></Button>
				</div>
			</div>
		</ShopifyProduct>
	);
};
